import React, { useState } from 'react';
import InformeView from './components/InformeView';
import InformePDF from './components/InformePDF';
import InformeSeguimientoView from './components/InformeSeguimientoView';
import InformeSeguimientoPDF from './components/InformeSeguimientoPDF';
import ConfirmModal from './components/ConfirmModal';
import { pdf } from '@react-pdf/renderer';
import './styles/App.css';

type TipoInforme = 'completo' | 'seguimiento';

function App() {
  const [tipoInforme, setTipoInforme] = useState<TipoInforme>('completo');
  const [informeData, setInformeData] = useState({
    paciente: { nombre: '', fecha: '' },
    campos: {} as Record<string, string>
  });
  const [showClearModal, setShowClearModal] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const handleFieldChange = (key: string, value: string) => {
    setInformeData(prev => ({
      ...prev,
      campos: { ...prev.campos, [key]: value }
    }));
    // Guardar en localStorage
    localStorage.setItem(`informe_cip_${key}`, value);
  };

  const handlePatientChange = (field: 'nombre' | 'fecha', value: string) => {
    setInformeData(prev => ({
      ...prev,
      paciente: { ...prev.paciente, [field]: value }
    }));
    localStorage.setItem(`informe_cip_patient_${field}`, value);
  };

  const handleClearFields = () => {
    setInformeData({ paciente: { nombre: '', fecha: '' }, campos: {} });
    // Limpiar localStorage
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('informe_cip_')) {
        localStorage.removeItem(key);
      }
    });
    setShowClearModal(false);
  };

  const handleGenerateAndDownloadPDF = async () => {
    setIsGeneratingPDF(true);
    try {
      const PDFComponent = tipoInforme === 'completo' 
        ? <InformePDF data={informeData} />
        : <InformeSeguimientoPDF data={informeData} />;
      
      const blob = await pdf(PDFComponent).toBlob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = tipoInforme === 'completo' ? 'informe-cip.pdf' : 'informe-seguimiento-cip.pdf';
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error generando PDF:', error);
      alert('Hubo un error al generar el PDF. Por favor, inténtalo de nuevo.');
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  return (
    <div className="app">
      <div className="toolbar">
        <div className="toolbar-content">
          <h1>Informe Multidisciplinar - CIP Marta Pérez</h1>
          <div className="toolbar-actions">
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginRight: '20px' }}>
              <label style={{ marginRight: '10px', fontWeight: 'bold', fontSize: '0.9rem' }}>Tipo de informe:</label>
              <button
                className={tipoInforme === 'completo' ? 'btn-primary' : 'btn-secondary'}
                onClick={() => setTipoInforme('completo')}
              >
                Completo
              </button>
              <button
                className={tipoInforme === 'seguimiento' ? 'btn-primary' : 'btn-secondary'}
                onClick={() => setTipoInforme('seguimiento')}
              >
                Seguimiento
              </button>
            </div>
            <button 
              className="btn-primary"
              onClick={handleGenerateAndDownloadPDF}
              disabled={isGeneratingPDF}
            >
              {isGeneratingPDF ? 'Generando PDF...' : 'Generar y Descargar PDF'}
            </button>
            <button 
              className="btn-secondary"
              onClick={() => setShowClearModal(true)}
            >
              Limpiar campos
            </button>
          </div>
        </div>
      </div>
      
      {tipoInforme === 'completo' ? (
        <InformeView 
          data={informeData}
          onFieldChange={handleFieldChange}
          onPatientChange={handlePatientChange}
        />
      ) : (
        <InformeSeguimientoView 
          data={informeData}
          onFieldChange={handleFieldChange}
          onPatientChange={handlePatientChange}
        />
      )}

      <ConfirmModal
        isOpen={showClearModal}
        title="Limpiar todos los campos"
        message="¿Estás seguro de que deseas borrar todos los datos del informe? Esta acción no se puede deshacer."
        confirmText="Sí, limpiar todo"
        cancelText="Cancelar"
        onConfirm={handleClearFields}
        onCancel={() => setShowClearModal(false)}
      />
    </div>
  );
}

export default App;